import { useContext } from 'react';

import * as SB from 'styles/index';

import { ColorName } from 'types';

import { useAppSelector } from 'redux/hooks';

import { LayoutContext } from 'contexts';

import { useSettingsBar } from './SettingsBar.hooks';
import * as S from './SettingsBar.styles';
import { OrderModal } from './components/OrderModal';

export function SettingsBar(): React.ReactElement {
  const { groupItemsRendered } = useSettingsBar();

  const { isOrderModalVisible } = useContext(LayoutContext);

  const { barColor } = useAppSelector((state) => state.settings);

  return (
    <S.Bar color={barColor as ColorName}>
      <SB.Inner>
        <S.Wrapper>{groupItemsRendered}</S.Wrapper>
      </SB.Inner>

      {isOrderModalVisible ? <OrderModal /> : undefined}
    </S.Bar>
  );
}
